import styles from "./WhyChooseGrid.module.scss";
import { resolveIcon } from "./iconMap";

/**
 * "Why choose" / benefits grid: each card has a marker icon, a title, and an
 * optional description. Surface-aware (default white). columns 2|3 (default 2);
 * partial last row left-aligned.
 *
 * The marker icon comes from the icon registry like every other icon: per-item
 * `icon` if given, else the section-level `markerIcon`, else the "check" glyph.
 */
export default function WhyChooseGrid({
  heading,
  subheading,
  items = [],
  columns = 2,
  markerIcon = "check",
  surface = "light", // "light" | "grey"
}) {
  if (!items.length) return null;

  return (
    <section
      className={`${styles.section} ${
        surface === "grey" ? styles.grey : styles.light
      }`}
    >
      <div className={styles.content}>
        {heading && <h2 className={styles.heading}>{heading}</h2>}
        {subheading && <p className={styles.subheading}>{subheading}</p>}

        <div className={styles.grid} style={{ "--cols": columns }}>
          {items.map((item, i) => (
            <div className={styles.card} key={i}>
              {/* Marker + title share a row (Figma: 8px gap, marker inline);
                  the description sits below both, flush with the card edge. */}
              <div className={styles.titleRow}>
                <img
                  className={styles.check}
                  src={resolveIcon(item.icon || markerIcon)}
                  alt=""
                  aria-hidden="true"
                />
                <p className={styles.title}>{item.title}</p>
              </div>
              {item.desc && <p className={styles.desc}>{item.desc}</p>}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
